<template>
  <SoRadioCard :value="bundle.code">
    <template #title>
      <div class="d-flex gap-1 align-center">
        <div class="bundle-card__title">{{ bundle.name }}</div>
        <v-spacer />
        <template v-if="bundle.code === cheapestBundleCode">
          <SoChip text="Lowest Cost &#10003;" :type="SoChipType.SUCCESS" />
        </template>
        <SoChip v-if="bundle.isNSC" text="NSC" :type="SoChipType.IMPORTANT" />
      </div>
    </template>
    <div class="bundle-card__grid">
      <div>Annual Cost</div>
      <div>
        {{
          formatMoney({
            amount: getAnnualCost(bundle),
          })
        }}
      </div>
      <div>Type</div>
      <div>{{ bundle.type }}</div>
      <div>duration</div>
      <div>
        {{ bundle.duration ? `${bundle.duration} months` : "N/A" }}
      </div>
      <div>Exit Fees</div>
      <div>
        <template v-if="bundle.exitFees.elec !== bundle.exitFees.gas">
          <div v-if="bundle.exitFees.elec !== undefined">
            Electricity: {{ formatMoney({ amount: bundle.exitFees.elec }) }}
          </div>
          <div v-if="bundle.exitFees.gas !== undefined">
            Gas: {{ formatMoney({ amount: bundle.exitFees.gas }) }}
          </div>
        </template>
        <template v-else>{{
          formatMoney({ amount: bundle.exitFee })
        }}</template>
      </div>
    </div>
  </SoRadioCard>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import { useTariffQuoter } from "@/stores/tariffQuoter"
  import { formatMoney } from "@/helpers/moneyHelpers"
  import { ITariffBundle } from "@/models/tariffBundle/tariffBundle.types"
  import tariffHelper from "@/helpers/tariffHelper"
  import SoRadioCard from "@/components/SoRadioCard.vue"
  import SoChip from "@/components/SoChip.vue"
  import { SoChipType } from "@/types/components/SoChip"

  export default defineComponent({
    components: {
      SoRadioCard,
      SoChip,
    },
    props: {
      bundle: {
        type: Object as PropType<ITariffBundle>,
        required: true,
      },
    },
    data() {
      return {
        tariffQuoter: useTariffQuoter(),
        formatMoney,
        SoChipType,
        tariffHelper,
      }
    },
    computed: {
      cheapestBundleCode() {
        const cpy = [...this.tariffQuoter.filteredBundles]
        return cpy.sort((a, b) =>
          this.getAnnualCost(a) > this.getAnnualCost(b) ? 1 : -1,
        )[0].code
      },
    },
    methods: {
      getAnnualCost(bundle: ITariffBundle) {
        return this.tariffQuoter.getAnnualCostForBundle(bundle)
      },
    },
  })
</script>

<style scoped>
  .bundle-card__title {
    white-space: pre-line;
    display: inline-block;
    word-break: break-word;
  }
  .bundle-card__grid {
    display: grid;
    grid-template-columns: 8fr 12fr;
    gap: 8px;
  }
</style>
